import { useAuth } from 'react-oidc-context';

export function useIdentityAuth() {
    const {
        user, events,
    } = useAuth();

    return {
        accessToken: user?.access_token,
        idToken: user?.id_token,
        user,
        events,
    };
}
